const patternGenerator = (key, type, isCustom, prefix) => {
  let pattern = isCustom ? `custom.${type}.${key}` : key;
  return `{{${prefix ? `${prefix}.` : ''}${pattern}}}`;
};
export default patternGenerator;
